import React from 'react';

const ButtonPrimary = ({name, onClick, isDisabled}) => {
  return (
    <button 
      className="btn btn--primary" 
      onClick={onClick ? onClick : null}
      disabled={isDisabled}
    >
      <span>{name}</span>
    </button>
  );
}

export default ButtonPrimary;